import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  FormControl,
  TextField,
  Paper,
  Breadcrumbs,
  Button,
  IconButton,
  Tooltip,
  Stack,
  useTheme,
  LinearProgress,
  Select,
  MenuItem,
  InputLabel,
  Alert,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import axios from "axios";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import useMediaQuery from "@mui/material/useMediaQuery";
import {
  fetchApidata,
  explorePostData,
  postData,
  getFetchData,
  requestMail,
  getLeaveentryData,
  getSpotActivityData,
} from "../../../store/reducers/Formapireducer";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever'
import { Formik } from "formik";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import Swal from "sweetalert2";
import { useProSidebar } from "react-pro-sidebar";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import ResetTvIcon from "@mui/icons-material/ResetTv";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import { tokens } from "../../../Theme";
import store from "../../../index";
import { LoadingButton } from "@mui/lab";
import { fetchExplorelitview } from "../../../store/reducers/Explorelitviewapireducer";
import Listviewpopup from "../Lookup";
import Popup from "../popup";
import { toast } from "react-hot-toast";
import { Productautocomplete, CheckinAutocomplete } from "../../../ui-components/global/Autocomplete";
import { formGap } from "../../../ui-components/global/utils";
import { leaveAppoval } from "../../../store/reducers/Listviewapireducer";
import { attachmentPost } from "../../../store/reducers/LoginReducer";
import FileUploadIconButton from "../../../ui-components/FileUploadButton";
import PushPinIcon from '@mui/icons-material/PushPin';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import MicIcon from '@mui/icons-material/Mic';

const EditSpotActivity = () => {
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const rowData = location.state || {};
  const mode = params.Mode;
  console.log(mode, "--mode");
  console.log(params, "--params");
  const [error, setError] = useState("");
  const rowSx = { height: 36, "& td, & th": { py: 0.5 } };
  const [files, setFiles] = useState([]);
  const { toggleSidebar, broken, rtl } = useProSidebar();
  const listViewData = useSelector((state) => state.listviewApi.rowData);
  const listViewColumn = useSelector((state) => state.listviewApi.columnData);
  const explorelistViewData = useSelector(
    (state) => state.exploreApi.explorerowData
  );
  const explorelistViewColumn = useSelector(
    (state) => state.exploreApi.explorecolumnData
  );
  const getLoading = useSelector((state) => state.formApi.getLoading);
  const listViewurl = useSelector((state) => state.globalurl.listViewurl);
  const isLoading = useSelector((state) => state.formApi.loading);
  const [pageSize, setPageSize] = useState(10);
  const [rowCount, setRowCount] = useState(0);
  const [show, setScreen] = React.useState("0");
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const Data = useSelector((state) => state.formApi.Data);
  const [loading, setLoading] = useState(false);
  const EMPID = sessionStorage.getItem("EmpId");
  const compID = sessionStorage.getItem("companyId");
  var accessID = params.accessID;
  var recID = params.id;
  const currentDate = new Date().toISOString().split("T")[0];
  const [errorMsgData, setErrorMsgData] = useState(null);

  useEffect(() => {
    fetch(process.env.PUBLIC_URL + "/validationcms.json")
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch validationcms.json");
        return res.json();
      })
      .then((data) => {
        setErrorMsgData(data);
      })
      .catch((err) => console.error("Error loading validationcms.json:", err));
  }, []);
  const fnLogOut = (props) => {
    Swal.fire({
      title: errorMsgData.Warningmsg[props],
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: props,
    }).then((result) => {
      if (result.isConfirmed) {
        if (props === "Logout") navigate("/");
        if (props === "Close") navigate(-1);
      }
    });
  };
  useEffect(() => {
    dispatch(getFetchData({ accessID, get: "get", recID }));
    var url = store.getState().globalurl.empGetAttachmentUrl;

    axios
      .get(url, {
        params: {
          empId: Data.EmpoyeeID,
          appId: recID,
        },
      })
      .then((response) => {
        setFiles(response.data);
      })
      .catch((err) => {
        setError("Failed to fetch attachments.");
        console.error(err);
      })
      .finally(() => setLoading(false));
  }, []);
  const dispatch = useDispatch();

  const leaveInitialValue = {
    applieddate: Data.Date,
    comments: Data.Comments,
    managerComments: Data.ManagerComments,
    ProName: Data.ProjectID
      ? { RecordID: Data.ProjectID, Name: Data.ProjectName }
      : null,
    overhead: Data.OverheadID
      ? { RecordID: Data.OverheadID, Name: Data.OverheadName || "" }
      : null,
    Status: mode === "AP" ? "AP" : mode === "QR" ? "QR" : Data.ApprovedStatus,
    SortOrder: "1",
    Disable: "N",
  };

  const leaveFNsave = async (values, resetForm, del, appStatus) => {
    setLoading(true);
    let action =
      mode === "A" && !del
        ? "insert"
        : mode === "E" && del
          ? "harddelete"
          : "update";
    const idata = {
      RecordID: recID,
      ApprovedStatus: values.Status,
      OverheadID : values?.overhead?.RecordID,
      ManagerComments: values.managerComments,
      ApprovedDate: currentDate,
      ApprovedBy: EMPID,
      Date: Data.Date,
      LocationID: Data.LocationID,
      ProjectID: values.ProName?.RecordID || 0,
      ProjectName: values.ProName?.Name || "",
      Comments: Data.Comments,
      EmpoyeeID: Data.EmpoyeeID,
      GateID: Data.GateID,
    };

    const response = await dispatch(
      postData({ accessID: accessID, action, idata })
    );
    if (response.payload.Status == "Y") {
      if (mode == "AP" || mode == "QR") {
        dispatch(
          requestMail({
            EmployeeID: EMPID,
            Type: "SP",
            RecordID: recID,
          })
        );
        console.log("--calling mail function");

      }
      setLoading(false);
      toast.success(response.payload.Msg);
      navigate(-1);

      // selectCellRowData({ rowData: {}, mode: "A", field: "" });
      resetForm();
    } else {
      setLoading(false);
      toast.error(response.payload.Msg);
    }
  };

  useEffect(() => {
    dispatch(getFetchData({ accessID, get: "get", recID }));
  }, []);
  async function fileUpload(file, EMPID, action, id, purpose) {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("empId", EMPID);
    formData.append("appId", Data.RecordID);
    formData.append("type", "SP");
    formData.append("source", "Manager");
    formData.append("action", action);
    formData.append("id", id);
    formData.append("purpose", purpose);
    const respose = await dispatch(attachmentPost({ data: formData }));

    if (respose.payload.success) {
      toast.success(respose.payload.message);
      //setShowtable(true);
      var url = store.getState().globalurl.empGetAttachmentUrl;
      axios
        .get(url, {
          params: {
            empId: EMPID,
            appId: Data.RecordID,
          },
        })
        .then((response) => {
          setFiles(response.data);
        })
        .catch((err) => {
          setError("Failed to fetch attachments.");
          console.error(err);
        })
        .finally(() => setLoading(false));
    } else {
      toast.success(respose.payload.message);
    }

    console.log("🚀 ~ fileUpload ~ respose:", respose);
  }
  return (
    <React.Fragment>
      {getLoading && <LinearProgress />}
      <Paper elevation={3} sx={{ margin: "0px 10px",background: "#F2F0F0",height:"40px" }}>
        <Box display="flex" justifyContent="space-between">
          <Box display="flex" borderRadius="3px" alignItems="center">
            {broken && !rtl && (
              <IconButton onClick={() => toggleSidebar()}>
                <MenuOutlinedIcon />
              </IconButton>
            )}
            <Box
              display={isNonMobile ? "flex" : "none"}
              borderRadius="3px"
              alignItems="center"
            >
              <Breadcrumbs
                maxItems={3}
                aria-label="breadcrumb"
                separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
              >
                {/* <Typography
                  variant="h5"
                  color="#0000D1"
                  sx={{ cursor: "default" }}
                >
                  {mode === "E" ? `Task` : "Task"}
             

                </Typography> */}
                <Typography
                  variant="h5"
                  color="#0000D1"
                  sx={{ cursor: "default",marginLeft:"10px",fontSize:"19px"}}
                >
                  {mode === "E" || mode == "V" ? `Onsite Activities` : ""}

                  {(mode === "AP" || mode === "QR") && mode !== "E" ? (
                    <Typography
                      variant="h5"
                      color="#0000D1"
                      sx={{ cursor: "default" }}
                    >
                      {`Onsite Activities`}
                      <Typography
                        variant="h5"
                        component="span"
                        sx={{
                          color:
                            mode == "AP"
                              ? "warning.main"
                              : mode == "QR"
                                ? "warning.main"
                                : "text.primary",
                          fontWeight: 600,
                          marginLeft: 1,
                        }}
                      >
                        {mode == "AP"
                          ? "-- Approve"
                          : mode == "QR"
                            ? "-- Query"
                            : ""}
                      </Typography>
                    </Typography>
                  ) : null}

                  {mode === "A" ? "Onsite Activities " : ""}
                </Typography>
              </Breadcrumbs>
            </Box>
          </Box>
          <Box display="flex">
            <Tooltip title="Close">
              <IconButton onClick={() => fnLogOut("Close")} color="error">
                <ResetTvIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Logout">
              <IconButton color="error" onClick={() => fnLogOut("Logout")}>
                <LogoutOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </Paper>

      {!getLoading ? (
        <Paper elevation={3} sx={{ margin: "10px" }}>
          {/* <Box m="20px"> */}
          <Formik
            initialValues={leaveInitialValue}
            enableReinitialize={true}
            onSubmit={(values, { resetForm }) => {
              setTimeout(() => {
                leaveFNsave(values, resetForm, false);
              }, 100);
            }}
          >
            {({
              errors,
              touched,
              handleBlur,
              handleChange,
              isSubmitting,
              values,
              handleSubmit,
              resetForm,
              setFieldValue,
            }) => (
              <form
                onSubmit={handleSubmit}
                onReset={() => {
                  // selectCellRowData({ rowData: {}, mode: "A", field: "" });
                  resetForm();
                }}
              >
                <Box
                  display="grid"
                  //   gap="30px"
                  gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                  gap={formGap}
                  padding={1}
                  sx={{
                    "& > div": {
                      gridColumn: isNonMobile ? undefined : "span 4",
                    },
                  }}
                >
                  <FormControl sx={{ gridColumn: "span 2", gap: "15px" }}>
                    {/* <FormControl
                    sx={{
                      gridColumn: "span 2",
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  > */}

                    {/* <TextField
                      id="outlined-basic"
                      label="Leave Type"
                      variant="standard"
                      value={selectltLookupData.LTlookupCode}
                      focused
                      required
                      inputProps={{ tabIndex: "-1" }}

                    />
                
                    <IconButton
                      sx={{ height: 40, width: 40 }}
                      onClick={() => handleShow("LT")}
                    >
                      <img src="https://img.icons8.com/color/48/null/details-popup.png" />
                    </IconButton>
                    <TextField
                      id="outlined-basic"
                      label=""
                      variant="standard"
                      value={selectltLookupData.LTlookupDesc}
                      fullWidth
                      focused
                      inputProps={{ tabIndex: "-1" }}
                    /> */}
                    {/* <FormControl
                    sx={{
                      width: isNonMobile ? 500 : "100%",
                      variant: "outlined",
                    }}
                  > */}
                    <TextField
                      name="applieddate"
                      type="date"
                      id="applieddate"
                      label="Applied Date"
                      variant="standard"
                      focused
                      inputFormat="YYYY-MM-DD"
                      value={values.applieddate}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={!!touched.applieddate && !!errors.applieddate}
                      helperText={touched.applieddate && errors.applieddate}
                      sx={{ gridColumn: "span 2" }}
                      inputProps={{
                        max: new Date().toISOString().split("T")[0],
                        readOnly: true,
                      }}
                      disabled={mode == "E" || mode == "V"}

                    //   disabled={mode == "E" && values.Status != "AL" && values.Status != "QR"}
                    />
                    <CheckinAutocomplete
                      name="ProName"
                      label="Project"
                      id="ProName"
                      value={values.ProName}
                      onChange={(newValue) => {
                        setFieldValue("ProName", newValue);
                      }}
                      error={!!touched.ProName && !!errors.ProName}
                      helperText={touched.ProName && errors.ProName}
                      url={`${listViewurl}?data={"Query":{"AccessID":"2054","ScreenName":"Project","Filter":"parentID=${compID}","Any":""}}`}
                      disabled={mode == "E" || mode == "V"}
                    // inputProps={
                    //   data.TaskSource === "Self"
                    //     ? { readOnly: true }
                    //     : { readOnly: false }
                    // }
                    />
                    {/* <FormControl
                      sx={{
                        gridColumn: "span 2",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    > */}
                       <CheckinAutocomplete
                        variant="outlined"
                        name="overhead"
                        label={
                          <>
                            OverHead
                            <span style={{ color: "red", fontSize: "20px" }}> * </span>
                          </>
                        }
                        id="overhead"
                        value={values.overhead}
                        onChange={(newValue) => {
                          setFieldValue("overhead", newValue);
                        }}
                        error={!!touched.overhead && !!errors.overhead}
                        helperText={touched.overhead && errors.overhead}
                        disabled={mode == "E" && (values.Status != "AL" && values.Status != "QR")}
                        //  onChange={handleSelectionFunctionname}
                        // defaultValue={selectedFunctionName}
                        url={`${listViewurl}?data={"Query":{"AccessID":"2032","ScreenName":"OverHead","Filter":"companyID='${compID}'","Any":""}}`}
                      /> 

                    {/* </FormControl> */}
                    <TextField
                      disabled={mode == "E" || mode == "V"}
                      //   disabled={mode == "E" && (values.Status != "AL" && values.Status != "QR") }
                      fullWidth
                      variant="outlined"
                      type="text"
                      label="Comments"
                      required
                      multiline
                      rows={6}
                      value={values.comments}
                      id="comments"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      name="comments"
                      error={!!touched.comments && !!errors.comments}
                      helperText={touched.comments && errors.comments}
                      sx={{
                        gridColumn: "span 2",
                        backgroundColor: "",
                        "& .MuiFilledInput-root": {
                          backgroundColor: "",
                        },
                      }}
                      focused
                    />

                    <TextField
                      fullWidth
                      variant="outlined"
                      type="text"
                      label="Manager Comments"
                      required
                      multiline
                      rows={6}
                      value={values.managerComments}
                      id="managerComments"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      name="managerComments"
                      error={
                        !!touched.managerComments && !!errors.managerComments
                      }
                      helperText={
                        touched.managerComments && errors.managerComments
                      }
                      sx={{
                        gridColumn: "span 2",
                        backgroundColor: "",
                        "& .MuiFilledInput-root": {
                          backgroundColor: "",
                        },
                      }}
                      focused
                      disabled={mode == "V"}
                    />

                    <TextField
                      disabled={mode == "V"}
                      select
                      label="Status"
                      id="Status"
                      name="Status"
                      value={values.Status}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      required
                      focused
                      variant="standard"
                    >
                      <MenuItem value="AP">Approved</MenuItem>

                      <MenuItem value="QR">Query</MenuItem>
                    </TextField>
                    {/* <Productautocomplete
                      name="leavetype"
                      label="Leave Type"
                      id="leavetype"
                      value={values.leavetype}
                      onChange={(newValue) => {
                        setFieldValue("leavetype", newValue);
                        dispatch(getLeaveentryData({
                          EmployeeID: EMPID ,
                          LeaveTypeID: newValue.RecordID  
                        }))
                     
                      }}
                      disabled={mode == "E" && values.Status != "AL"}
                      //value={selectedProjectOptions}
                      //onChange={handleSelectionProjectname}
                      // defaultValue={selectedProjectName}
                      url={`https://ess.beyondexs.com/api/wslistview_mysql.php?data={"Query":{"AccessID":"2092","ScreenName":"Leave Type","Filter":"parentID=${compID}","Any":""}}`}
                    /> */}
                    {/* 
                    <Productautocomplete
                      name="leavetype"
                      label="Leave Type"
                      id="leavetype"
                      value={values.leavetype}
                      onChange={async (newValue) => {
                        setFieldValue("leavetype", newValue);
                        if (newValue?.RecordID) {
                          await Balancedayfind(newValue.RecordID);
                        }
                      }}
                      disabled={mode == "E" && values.Status != "AL" && values.Status != "QR"}
                      url={`https://ess.beyondexs.com/api/wslistview_mysql.php?data={"Query":{"AccessID":"2107","ScreenName":"Leave Type","Filter":"parentID='${compID}' AND EmployeeID='${EMPID}'" ,"Any":""}}`}
                    /> */}

                    {/* </FormControl> */}
                    {/* <FormControl
                      focused
                      variant="filled"
                      sx={{ gridColumn: "span 2" }}
                      disabled={mode == "E" && values.Status != "AL" && values.Status != "QR"}
                    >
                      <InputLabel variant="standard" id="LeavePart">
                        {
                          <span>
                            Leave Part <span style={{ color: "red" }}>*</span>
                          </span>
                        }
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-filled-label"
                        fullWidth
                        variant="standard"
                        type="text"
                        value={values.LeavePart}
                        id="LeavePart"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        name="LeavePart"
                        required
                        focused
                      >
                        <MenuItem value="FH">First Half</MenuItem>
                        <MenuItem value="SH">Second Half</MenuItem>
                        <MenuItem value="N">Full Day</MenuItem>
                      </Select>
                    </FormControl>
                    <TextField
                       disabled={mode == "E" && values.Status != "AL" && values.Status != "QR"}
                      name="FromDate"
                      type="date"
                      id="FromDate"
                      label="From Date"
                      //inputFormat="YYYY-MM-DD"
                      variant="standard"
                      focused
                      value={values.FromDate}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      required
                      sx={{ gridColumn: "span 2" }}
                    />
                    <TextField
                        disabled={mode == "E" && values.Status != "AL" && values.Status != "QR"}
                      name="ToDate"
                      type="date"
                      id="ToDate"
                      label="To Date"
                      //inputFormat="YYYY-MM-DD"
                      variant="standard"
                      focused
                      value={values.ToDate}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      required
                      sx={{ gridColumn: "span 2" }}
                      inputProps={{
                        min:
                          values.FromDate ||
                          new Date().toISOString().split("T")[0],
                      }}
                    />
                    <TextField
                      fullWidth
                      variant="standard"
                      type="number"
                      label="Balance Days"
                      id="BalanceDay"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      // value={selectedLeavetypebalance}
                      value={selectedLeavetypebalance || values.BalanceDay}
                      // value={
                      //   Number(values.totaldays) -
                      //   Number(values.availableleave)
                      // }
                      name="BalanceDay"
                      // error={
                      //   !!touched.elligibledays && !!errors.elligibledays
                      // }
                      // helperText={
                      //   touched.elligibledays && errors.elligibledays
                      // }
                      disabled={mode == "E" && values.Status != "AL" && values.Status != "QR"}
                      focused
                      onWheel={(e) => e.target.blur()}
                      InputProps={{
                        readOnly: true,
                        inputProps: {
                          style: { textAlign: "right" },
                        },
                      }}
                    /> */}
                    {/* <TextField
                        name="applieddate"
                        type="date"
                        id="applieddate"
                        label="Applied Date"
                        variant="standard"
                        focused
                        inputFormat="YYYY-MM-DD"
                        value={values.applieddate}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={!!touched.applieddate && !!errors.applieddate}
                        helperText={touched.applieddate && errors.applieddate}
                        sx={{ gridColumn: "span 2" }}
                        inputProps={{ max: new Date().toISOString().split("T")[0] }}
                      /> */}
                    {/* <TextField
                    //   disabled={mode == "E" && (values.Status != "AL" && values.Status != "QR") }
                      fullWidth
                      variant="outlined"
                      type="text"
                      label="Comments"
                      required
                      multiline
                      rows={6}
                      value={values.comments}
                      id="comments"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      name="comments"
                      error={!!touched.comments && !!errors.comments}
                      helperText={touched.comments && errors.comments}
                      sx={{
                        gridColumn: "span 2",
                        backgroundColor: "",
                        "& .MuiFilledInput-root": {
                          backgroundColor: "",
                        },
                      }}
                      focused
                    /> */}

                    {/* {mode == "M" || ( mode == "E" && (values.Status == "RJ" || values.Status == "QR") ) ? (
                      <TextField
                      disabled={mode == "E" && values.Status != "AL"}
                        fullWidth
                        variant="outlined"
                        type="text"
                        label="Manager Comments"
                        required
                        multiline
                        rows={6}
                        value={values.managerComments}
                        id="managerComments"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        name="managerComments"
                        sx={{
                          gridColumn: "span 2",
                        }}
                        focused
                      />
                    ): false}  */}
                    {/*  {mode == "M" && (
                      <TextField
                        select
                        label="Status"
                        id="Status"
                        name="Status"
                        value={values.Status}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        required
                        focused
                        variant="standard"
                      >
                        {mode != "M" && <MenuItem value="AL">Applied</MenuItem>}
                        <MenuItem disabled={mode != "M"} value="AP">
                          Approved
                        </MenuItem>
                        <MenuItem disabled={mode != "M"} value="RJ">
                          Rejected
                        </MenuItem>
                        {mode == "M" && <MenuItem  value="QR">
                          Query
                        </MenuItem>}
                      </TextField>
                    )}

                    {mode == "E" && values.Status == "AP" && (
                      <Alert variant="filled" sx={{ mt: 1 }} severity="success">
                        Your Leave Request Approved.
                      </Alert>
                    )}
                    {mode == "E" && values.Status == "RJ" && (
                      <Alert variant="filled" sx={{ mt: 1 }} severity="error">
                        Your Leave Request Rejected.
                      </Alert>
                    )}

                    {mode == "E" && values.Status == "QR" && (
                      <Alert variant="filled" sx={{ mt: 1 }} severity="warning">
                        Your leave request status Query.
                      </Alert>
                    )} */}
                  </FormControl>

                  {/* <Box
                    display="flex"
                    padding={1}
                    justifyContent="flex-end"
                    gridColumn="span 4"
                    mt="40px"
                    gap={2}
                  >
                    {mode != "M" && (values.Status == "AL" || values.Status == "QR" || mode == "A") && (
                      <LoadingButton
                        color="secondary"
                        variant="contained"
                        type="submit"
                        loading={isLoading}
                      >
                        Save
                      </LoadingButton>
                    )}
                    {mode == "M" && (
                      <LoadingButton
                        color="secondary"
                        variant="contained"
                        type="submit"
                        loading={isLoading}
                      >
                        Save
                      </LoadingButton>
                    )}
                    {mode != "M" && values.Status == "AL" && (
                      <Button
                        color="error"
                        variant="contained"
                        onClick={() => {
                          Swal.fire({
                            title: `Do you want Delete?`,
                            icon: "warning",
                            showCancelButton: true,
                            confirmButtonColor: "#3085d6",
                            cancelButtonColor: "#d33",
                            confirmButtonText: "Confirm",
                          }).then((result) => {
                            if (result.isConfirmed) {
                              leaveFNsave(values, resetForm, "harddelete");
                              // navigate(-1);
                            } else {
                              return;
                            }
                          });
                        }}
                      >
                        Delete
                      </Button>
                    )}
                    {mode == "M" && (
                      <Button
                        color="error"
                        variant="contained"
                        onClick={() => {
                          Swal.fire({
                            title: `Do you want Delete?`,
                            icon: "warning",
                            showCancelButton: true,
                            confirmButtonColor: "#3085d6",
                            cancelButtonColor: "#d33",
                            confirmButtonText: "Confirm",
                          }).then((result) => {
                            if (result.isConfirmed) {
                              leaveFNsave(values, resetForm, "harddelete");
                              // navigate(-1);
                            } else {
                              return;
                            }
                          });
                        }}
                      >
                        Delete
                      </Button>
                    )}
                    <Button
                      type="reset"
                      color="warning"
                      variant="contained"
                      onClick={() => {
                        navigate(-1);
                      }}
                    >
                      Cancel
                    </Button>
                    {/* <Popup
                      title="Leave Type"
                      openPopup={openLTpopup}
                      setOpenPopup={setOpenLTpopup}
                    >
                      <Listviewpopup
                        accessID="2092"
                        screenName="Leave Type"
                        childToParent={childToParent}
                        filterName={"parentID"}
                        filterValue={compID}
                      />
                    </Popup> 
                  </Box> */}
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    mt="40px"
                    padding={1}
                    gridColumn="span 4"
                  >
                    {/* Left: Attachment Label */}
                    <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
                      Attachment
                    </Typography>

                    {/* Center: Upload Icon */}
                    {(mode === "AP" || mode === "QR" || mode === "V") ? (
                      // <Box display="flex" alignItems="center" gap={1}>
                      //   <FileUploadIconButton onFileSelect={fileUpload} />
                      // </Box>
                      <>
                        <TextField
                          name="purpose"
                          type="text"
                          id="purpose"
                          label="Purpose"
                          variant="standard"
                          focused
                          value={values.purpose}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          error={!!touched.purpose && !!errors.purpose}
                          helperText={touched.purpose && errors.purpose}
                          sx={{ gridColumn: "span 2", height: "20px" }}
                          InputLabelProps={{ shrink: true }}

                        />

                        <Box display="flex" alignItems="center" gap={1}>
                          <FileUploadIconButton onFileSelect={(file) => {
                            fileUpload(
                              file,
                              Data.EmpoyeeID,
                              "upload",
                              "",
                              values.purpose
                            )
                            setFieldValue("purpose", "");
                          }}
                          />
                        </Box>
                      </>
                    ) : (
                      <Box /> // Keeps spacing if icon is not shown
                    )}

                    {/* Right: Buttons */}
                    <Box display="flex" alignItems="center" gap={2}>
                      <LoadingButton
                        disabled={mode === "V"}
                        color="secondary"
                        variant="contained"
                        type="submit"
                        loading={isLoading}
                      >
                        Confirm
                      </LoadingButton>
                      <Button
                        type="reset"
                        color="warning"
                        variant="contained"
                        onClick={() => {
                          navigate(-1);
                        }}
                      >
                        Cancel
                      </Button>
                    </Box>
                  </Box>

                </Box>
              </form>
            )}
          </Formik>
          {/* </Box> */}
        </Paper>
      ) : (
        false
        // <Box display="flex" justifyContent="center" mt={4}>
        //   <Typography variant="h6" color="textSecondary">
        //     Loading data, please wait...
        //   </Typography>
        // </Box>
      )}
      {(mode === "AP" || mode === "QR" || mode === "V") && files.length > 0 ? (
        <Box mt={2}>
          <Paper elevation={3} sx={{ padding: 2 }}>
            <TableContainer component={Paper}>
              <Table size="small">
                <TableHead>
                  <TableRow sx={rowSx}>
                    <TableCell width={20}><strong>SL#</strong></TableCell>
                    <TableCell width={30}><strong></strong></TableCell>
                    <TableCell width={160}><strong>Uploaded Date</strong></TableCell>
                    <TableCell width={250}><strong>Filename</strong></TableCell>
                    <TableCell width={150}><strong>Purpose</strong></TableCell>
                    <TableCell width={100}><strong>Source</strong></TableCell>
                    <TableCell ><strong>View</strong></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {files.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={4} align="center">
                        No files uploaded yet.
                      </TableCell>
                    </TableRow>
                  ) : (
                    files.map((file, index) => (
                      <TableRow key={file.id || index} sx={rowSx}>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>
                          {file.filename?.toLowerCase().endsWith(".pdf") && (
                            <Tooltip title="PDF File">
                              <AttachFileIcon fontSize="small" color="primary" />
                            </Tooltip>
                          )}

                          {/\.(jpg|jpeg|png|gif)$/i.test(file.filename) && (
                            <Tooltip title="Image File">
                              <CameraAltIcon fontSize="small" color="primary" />
                            </Tooltip>
                          )}

                          {/\.(mp3|wav|ogg)$/i.test(file.filename) && (
                            <Tooltip title="Audio File">
                              <MicIcon fontSize="small" color="primary" />
                            </Tooltip>
                          )}
                        </TableCell>
                        <TableCell>{file.uploadedDate}</TableCell>
                        <TableCell>{file.filename}</TableCell>
                        <TableCell>{file.purpose}</TableCell>
                        <TableCell>{file.source}</TableCell>
                        <TableCell>
                          <Tooltip title="Open File">
                            <IconButton
                              color="primary"
                              component="a"
                              href={file.url}
                              target="_blank"
                              rel="noopener noreferrer"
                              size="small"
                            >
                              <OpenInNewIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="delete">
                            <IconButton
                              color="error"
                              onClick={() => fileUpload(
                                file.filename,
                                Data.EmpoyeeID,
                                "delete",
                                file.id,
                                file.purpose
                              )}
                              size="small"
                            >
                              <DeleteForeverIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </Box>
      ) : null}
    </React.Fragment>
  );
};

export default EditSpotActivity;
